import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import {
  colorMD,
  colorTheme,
  variantNumber,
  variantType
} from "@/design/colors/Color";

const state = {
  /**
   * Current selected (active) application
   * @type {{title: String, icon: String, name: String}}
   */
  application: undefined,

  /**
   * Left drawer visibility
   * @type Boolean
   */
  drawerLeft: true,

  /**
   * Right drawer visibility
   * @type Boolean
   */
  drawerRight: false,

  /**
   * Visible Jump Commands
   * @type Boolean
   */
  visibleJump: true,

  /**
   * Visible Options
   * @type Boolean
   */
  visibleOptions: false,

  /**
   *  Uses Tabs as a Application selector
   *  @type {Boolean}
   */
  usesAppTabs: false,

  /**
   * Uses Modal Jump Dialog as a module selector
   * @type {Boolean}
   */
  usesModalDialogJump: true,

  /**
   * Uses Sidebar Image
   * @type {Boolean}
   */
  usesSidebarImage: false,

  /**
   * Dialog with/without Toolbar
   * @type {Boolean}
   */
  dialogToolbarStyle: false,

  /**
   * Application Bar Material Design Color
   * @type {{name:String, variantType:String, variantNumber:Number}}
   */
  appBarColor: {
    name: colorMD.indigo,
    variantType: variantType.darken,
    variantNumber: variantNumber.n4
  },

  /**
   * data Table Toolbar Material Design Color
   */
  dataTableToolbarColor: {
    name: colorMD.indigo,
    variantType: variantType.darken,
    variantNumber: variantNumber.n2
  },

  /**
   *  Dialog Title Text Material Design Color
   *  @type {{name:String, variantType:String, variantNumber:Number}}
   */
  dialogTitleColor: {
    name: colorMD.indigo,
    variantType: variantType.darken,
    variantNumber: variantNumber.n2
  },

  /**
   * Details Toolbar Material Material Design Color
   * @type {{name:String, variantType:String, variantNumber:Number}}
   */
  detailsToolbarColor: {
    name: colorMD.indigo,
    variantType: variantType.darken,
    variantNumber: variantNumber.n1
  },

  /**
   * Menu Item Material Design Color
   * @type {{name:String, variantType:String, variantNumber:Number}}
   */
  menuItemColor: {
    name: colorMD.indigo,
    variantType: variantType.darken,
    variantNumber: variantNumber.n2
  },

  /**
   * Progress Material Design Color
   * @type {{name:String, variantType:String, variantNumber:Number}}
   */
  progressColor: {
    name: colorTheme.primary,
    variantType: undefined,
    variantNumber: undefined
  },

  /**
   * Command Buttons Material Design Color
   * @type {{name:String, variantType:String, variantNumber:Number}}
   */
  buttonColor: {
    name: colorTheme.primary,
    variantType: undefined,
    variantNumber: undefined
  },

  /**
   * Command Button Text Style
   * @type {Boolean}
   */
  buttonTextStyle: true,

  /**
   * Command Button Outlined
   * @type {Boolean}
   */
  buttonOutlined: false,

  /**
   * Dialog Cancel Button color
   */
  buttonCancelColor: {
    name: colorTheme.secondary,
    variantType: undefined,
    variantNumber: undefined
  },

  /**
   * Delete Color (implements Material Design Color)
   * @type {{name:String, variantType:String, variantNumber:Number}}
   */
  deleteColor: {
    name: colorTheme.error,
    variantType: variantType.lighten,
    variantNumber: variantNumber.n1
  }
};

export default {
  actions,
  mutations,
  getters,
  state,
  namespaced: true
};
